<!-- 分类检验标准 -->
<style>
.baoyangxianginput {
  width: 1.25rem;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/classification/inspection/standards/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('fenleijianyanbiaozhunmingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')">
            <yi_dictionary_select :type="'QUALITY_INSPECTION_TYPE'" :ids.sync="yt.conditions.inspectionType">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jianyanfenlei')">
            <yi_dictionary_select :type="'INSPECTION_CLASSIFICATION'" :ids.sync="yt.conditions.inspectionClassification"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(orderBy)">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1', beforeShowEditDialog); setAddDefaultValue();" v-if="utils.checkPower('web_quality_management_classification_inspection_standards_create')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 自定义字段显示 -->
      <template #tupian="scope">
        <div>
          <div v-if="!scope.row.imageList">
            <el-button type="text" :loading="scope.row.fileLoading" @click="downFiles(scope.row)">点击查看</el-button>
          </div>
          <div v-if="scope.row.imageList && scope.row.imageList.length > 0">
            <el-image style="width: 100px; height: 100px" :src="scope.row.imageList[0]" :preview-src-list="scope.row.imageList">
            </el-image>
          </div>
        </div>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('fuzhi', scope.row, 'w1'); setAddDefaultValue()" v-if="utils.checkPower('web_quality_management_classification_inspection_standards_copy')">
              {{ $t('fuzhi') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('mingxi', scope.row, '80%')" v-if="utils.checkPower('web_quality_management_classification_inspection_standards_detail')">
              {{ $t('mingxi') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button v-if="utils.checkPower('web_quality_management_classification_inspection_standards_update')" type="text" @click="yt.showEditDialog('bianji', scope.row, 'w1')">{{ $t('bianji') }} </el-button>
            <el-button v-if="utils.checkPower('web_quality_management_classification_inspection_standards_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/classification/inspection/standards/delete')">{{ $t('shanchu') }}</el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 保养项 -->
      <template v-if="yt.editObj.action == 'baoyangxiang'">
        <div class="dialog-scroller">
          <maintenance_item :maintainItem="yt.editObj" ref="maintainItem"></maintenance_item>
        </div>
      </template>
      <!-- 新增弹窗 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <!-- <div class="dialog-scroller"> -->
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('fenleijianyanbiaozhunmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')" required>
            <yi_dictionary_select :type="'QUALITY_INSPECTION_TYPE'" :ids.sync="yt.editObj.inspectionType">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jianyanfenlei')" required>
            <yi_dictionary_select :type="'INSPECTION_CLASSIFICATION'" :ids.sync="yt.editObj.inspectionClassification">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <yi_dictionary_select :type="'SYSTEM_YES_NO'" :ids.sync="yt.editObj.enable"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <!-- </div> -->
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/classification/inspection/standards/create')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '分类检验标准-新增分类检验标准' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 复制弹窗 -->
      <template v-if="yt.editObj.action == 'fuzhi'">
        <!-- <div class="dialog-scroller"> -->
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('fenleijianyanbiaozhunmingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('jianyanleixing')" required>
            <yi_dictionary_select :type="'QUALITY_INSPECTION_TYPE'" :ids.sync="yt.editObj.inspectionType" @change="getMethods">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('jianyanfangshi')" required>
            <el-select :max="1" filterable :clearable="true" v-model="yt.editObj.inspectionMethodId">
              <el-option v-for="(item, index) in inspectionMethods" :key="index" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('jianyanfenlei')" required>
            <yi_dictionary_select :type="'INSPECTION_CLASSIFICATION'" :ids.sync="yt.editObj.inspectionClassification">
            </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('shifouqiyong')" required>
            <yi_dictionary_select :type="'SYSTEM_YES_NO'" :ids.sync="yt.editObj.enable"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <!-- </div> -->
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/classification/inspection/standards/copy')" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '分类检验标准-复制分类检验标准' } }">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 编辑弹窗 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
            <el-form-item :label="$t('fenleijianyanbiaozhunmingcheng')" required>
              <el-input v-model="yt.editObj.name" disabled></el-input>
            </el-form-item>
            <el-form-item :label="$t('jianyanleixing')" required>
              <yi_dictionary_select :type="'QUALITY_INSPECTION_TYPE'" :ids.sync="yt.editObj.inspectionType" disabled>
              </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('jianyanfenlei')" required>
              <yi_dictionary_select :type="'INSPECTION_CLASSIFICATION'" :ids.sync="yt.editObj.inspectionClassification" disabled> </yi_dictionary_select>
            </el-form-item>
            <el-form-item :label="$t('shifouqiyong')" required>
              <yi_dictionary_select :type="'SYSTEM_YES_NO'" :ids.sync="yt.editObj.enable"> </yi_dictionary_select>
            </el-form-item>
          </el-form>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="store.state.global_loading" size="mini" @click="yt.req('POST', '/web/classification/inspection/standards/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'mingxi'">
        <div class="dialog-scroller">
          <standards_item :standards="yt.editObj"></standards_item>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import standards_item from '@@/pages/web/quality_management/classification_inspection_standards/standards_item';
export default {
  name: 'web_equipment_classification_inspection_standards',
  components: {
    standards_item
  },
  data() {
    return {
      inspectionMethods: [],
      leaveFactoryDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      list: [],
      orderBy: { orderBy: 'createTime desc' },
      columns: [
        {
          label: 'fenleijianyanbiaozhunmingcheng',
          prop: 'name'
        },
        {
          label: 'jianyanleixing',
          prop: 'inspectionType',
          type: 'dictionary',
          key: 'QUALITY_INSPECTION_TYPE',
          width: 150
        },
        {
          label: 'jianyanfenlei',
          prop: 'inspectionClassification',
          type: 'dictionary',
          key: 'INSPECTION_CLASSIFICATION',
          width: 150
        },
        {
          label: 'fenleijianyanbiaozhunbanben',
          prop: 'version',
        },
        {
          label: 'shifouqiyong',
          prop: 'enable',
          type: 'dictionary',
          key: 'SYSTEM_YES_NO',
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 350,
          fixed: 'right'
        }
      ],
      ids: ''
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      };
      this.yt.get(1);
      this.utils.event_hub.$on('BASE_MAINTENANCE_REFRESH', () => {
        this.yt.get();
      });
    }, 300);
  },
  watch: {},
  methods: {
    setCopyDefaultValue() {
      this.$set(this.yt.editObj, 'inspectionMethodId', null)
      this.yt.editObj.type = null;
      this.inspectionMethods = [];
    },
    // 根据文件id下载文件
    downFiles(row) {
      const fileIdList = row.fileIdList;
      if (fileIdList && fileIdList.length > 0) {
        this.$set(row, 'fileLoading', true);
        this.http.get('/web/customer/files/getFileByIds', {
          params: {
            ids: fileIdList
          }
        }).then(res => {
          if (res.data && res.data.length > 0) {
            const imageList = res.data.map(i => i.url);
            this.$set(row, 'imageList', imageList);
          } else {
            this.$message.warning(this.$t('meiyoutupian'));
          }
        }).catch(err => {
          this.$message.error(this.$t(err));
        }).finally(() => {
          this.$set(row, 'fileLoading', false);
        });
      } else {
        this.$message.warning(this.$t('meiyoutupian'));
      }

    },
    getMethods() {
      this.yt.editObj.inspectionMethodId = null;
      this.inspectionMethods = [];
      // if(this.yt.editObj.inspectionType==undefined || this.yt.editObj.inspectionType==null){
      //   this.$message.warning(this.$t('gaijianyanleixingbucunzaijianyanfangshi'));
      //   return;
      // }
      this.http.get('/web/quality/inspection/method/list', {
        params: {
          inspectionType: this.yt.editObj.inspectionType
        }
      }).then(res => {
        if (res.data && res.data.length > 0) {
          this.inspectionMethods = res.data;
        } else {
          this.$message.warning(this.$t('gaijianyanleixingbucunzaijianyanfangshi'));
        }
      }).catch(err => {
        this.$message.error(this.$t(err));
      })
    },
    setAddDefaultValue() {
      if (this.yt.editObj.action == 'fuzhi') {
        this.$set(this.yt.editObj, 'inspectionMethodId', null)
        this.yt.editObj.name = '';
        this.yt.editObj.inspectionType = '';
        this.yt.editObj.inspectionClassification = '';
      }
      this.yt.editObj.enable = '1';
    },
    beforeShowEditDialog(editObj) {
      this.yt.editObj.enable = 1;
      return editObj;
    },
    addItem() {
      this.yt.editObj.itemList.push({
        part: '',
        content: '',
        attention: ''
      });
    },
    deleteItem(key) {
      this.yt.editObj.itemList = this.yt.editObj.itemList.filter((item, index) => {
        return index !== key;
      });
    }
  }
};
</script>
